module.exports = __webpack_public_path__ + "static/media/10.question.89e3e430.mp4";